<div>
  <select [(ngModel)]="selectedCategory">
    @for (category of categoryList; track category) {
      <option >{{category}}</option>
    }
  </select>
  <!--<div> <button>Add New</button></div>-->

</div>